import { ExploreCustomStreamsSectionV2 } from './explore-custom-streams-section-v2.tsx';
import { ExploreDataStreamsSectionV2 } from './explore-data-streams-section-v2.tsx';
import { ExploreHowSynopticWorksSectionV2 } from './explore-how-synoptic-works-section-v2.tsx';
import { ExploreNewStreamsSectionV2 } from './explore-new-streams-section-v2.tsx';
import { explorePageV2 } from './explore-page-v2.css.ts';
import { ExploreStreamPackagesSectionV2 } from './explore-stream-packages-section-v2.tsx';
import { ExploreTerminalSectionV2 } from './explore-terminal-section-v2.tsx';

const ExplorePageV2 = () => (
  <div className={explorePageV2} data-testid="explore-page-v2">
    <ExploreTerminalSectionV2 />
    <ExploreNewStreamsSectionV2 />
    <ExploreDataStreamsSectionV2 />
    <ExploreCustomStreamsSectionV2 />
    <ExploreStreamPackagesSectionV2 />
    <ExploreHowSynopticWorksSectionV2 />
  </div>
);

export default ExplorePageV2;
